interface Syllabus {
    text: string
}

export interface PaperDetail {
    contentId?: string;
    syllabus: Syllabus;
    id: string;
    name: string;
    type: string;
}



export interface ExistingScheduledTest {
    paperDetail: PaperDetail;
    testType: string;
    duration: string;
    status: string;
    codeName: string;
    displayName: string;
    scheduleID: string;
    scheduleDate: string;
    scheduleEndDate: string;
    maxAttempt: string;
    questionsCount: number;
    blockRevisionTime?: string;
    _id: string;
    testId: string;
}
export enum contentType {
    scheduledTests="Scheduled Tests",
    conceptTests="Concept Tests", 
    chapterTests="Chapter Tests",
    studyNotes="Study Notes", 
    formula="Formula", 
    video="Video"
}
export interface fetchContentBody{
    courseId:string,
    contentType:contentType,
    packages:{
       id:string,
       sku:string
    }[]
}